import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36e8243f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8243f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e8243f')) {
      api.createRecord('36e8243f', component.options)
    } else {
      api.reload('36e8243f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36e8243f&scoped=true", function () {
      api.rerender('36e8243f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/paychannel/index.vue"
export default component.exports